import * as GeneralRepository from "./general-repository";
import * as PrimerPagoProvider from "../providers/primer-pago-provider"

export const obtenerListaPagos = async (idSolicitudMultiple) => {
    const response = await PrimerPagoProvider.obtenerListaPagos(idSolicitudMultiple)
    if(response.auditResponse.codigoRespuesta === '0') {
        return {
            error: null,
            listaPagos: response.entity.data
        }
    } else {
        if(response.auditResponse.detalle !== undefined && response.auditResponse.detalle.renovarToken) {
            const responseToken = await GeneralRepository.renovarToken()
            if(responseToken !== null && responseToken.error === null) {
                return await obtenerListaPagos(idSolicitudMultiple)
            } else {
                return {
                    error: response.auditResponse,
                    listaPagos: null
                }
            }
        } else {
            return {
                error: response.auditResponse,
                listaPagos: null
            }
        }
    }
}

export const obtenerPagosSolicitud = async (idSolicitudMultiple) => {
    const response = await PrimerPagoProvider.obtenerPagosSolicitud(idSolicitudMultiple)
    if(response.auditResponse.codigoRespuesta === '0') {
        return {
            error: null,
            pagos: response.entity.data
        }
    } else {
        if(response.auditResponse.detalle !== undefined && response.auditResponse.detalle.renovarToken) {
            const responseToken = await GeneralRepository.renovarToken()
            if(responseToken !== null && responseToken.error === null) {
                return await obtenerPagosSolicitud(idSolicitudMultiple)
            } else {
                return {
                    error: response.auditResponse,
                    pagos: null
                }
            }
        } else {
            return {
                error: response.auditResponse,
                pagos: null
            }
        }
    }
}

export const registrarPagos = async (body, idSolicitudMultiple) => {
    const response = await PrimerPagoProvider.registrarPagos(body, idSolicitudMultiple)
    if(response.auditResponse.codigoRespuesta === '0') {
        return {
            error: null,
            pagos: response.entity.data
        }
    } else {
        if(response.auditResponse.detalle !== undefined && response.auditResponse.detalle.renovarToken) {
            const responseToken = await GeneralRepository.renovarToken()
            if(responseToken !== null && responseToken.error === null) {
                return await registrarPagos(body, idSolicitudMultiple)
            } else {
                return {
                    error: response.auditResponse,
                    pagos: null
                }
            }
        } else {
            return {
                error: response.auditResponse,
                pagos: null
            }
        }
    }
}

export const pagarSafetyPay = async (body) => {
    const response = await PrimerPagoProvider.pagoSafetyPay(body)
    if(response.auditResponse.codigoRespuesta === '0') {
        return {
            error: null,
            safetypay: response.entity.data
        }
    } else {
        if(response.auditResponse.detalle !== undefined && response.auditResponse.detalle.renovarToken) {
            const responseToken = await GeneralRepository.renovarToken()
            if(responseToken !== null && responseToken.error === null) {
                return await pagarSafetyPay(body)
            } else {
                return {
                    error: response.auditResponse,
                    safetypay: null
                }
            }
        } else {
            return {
                error: response.auditResponse,
                safetypay: null
            }
        }
    }
}

export const pagarPagoLink = async (body) => {
    const response = await PrimerPagoProvider.pagoLinkNiubiz(body)
    if(response.auditResponse.codigoRespuesta === '0') {
        return {
            error: null,
            pagolink: response.entity.data
        }
    } else {
        if(response.auditResponse.detalle !== undefined && response.auditResponse.detalle.renovarToken) {
            const responseToken = await GeneralRepository.renovarToken()
            if(responseToken !== null && responseToken.error === null) {
                return await pagarPagoLink(body)
            } else {
                return {
                    error: response.auditResponse,
                    pagolink: null
                }
            }
        } else {
            return {
                error: response.auditResponse,
                pagolink: null
            }
        }
    }
}

export const validarPagoLink = async (idSolicitudMultiple) => {
    const response = await PrimerPagoProvider.validarEstadoPagoLink(idSolicitudMultiple)
    if(response.auditResponse.codigoRespuesta === '0') {
        return {
            error: null,
            pagolink: response.entity.data
        }
    } else {
        if(response.auditResponse.detalle !== undefined && response.auditResponse.detalle.renovarToken) {
            const responseToken = await GeneralRepository.renovarToken()
            if(responseToken !== null && responseToken.error === null) {
                return await validarPagoLink(idSolicitudMultiple)
            } else {
                return {
                    error: response.auditResponse,
                    pagolink: null
                }
            }
        } else {
            return {
                error: response.auditResponse,
                pagolink: null
            }
        }
    }
}

export const obtenerTokenNiubiz = async (body) => {
    const response = await PrimerPagoProvider.obtenerTokenNiubiz(body)
    if(response.auditResponse.codigoRespuesta === '0') {
        return {
            error: null,
            token: response.entity.data
        }
    } else {
        if(response.auditResponse.detalle !== undefined && response.auditResponse.detalle.renovarToken) {
            const responseToken = await GeneralRepository.renovarToken()
            if(responseToken !== null && responseToken.error === null) {
                return await obtenerTokenNiubiz(body)
            } else {
                return {
                    error: response.auditResponse,
                    token: null
                }
            }
        } else {
            return {
                error: response.auditResponse,
                token: null
            }
        }
    }
}

export const obtenerAutorizacionNiubiz = async (body) => {
    const response = await PrimerPagoProvider.obtenerAutorizacionNiubiz(body)
    if(response.auditResponse.codigoRespuesta === '0') {
        return {
            error: null,
            autorizacion: response.entity.data
        }
    } else {
        if(response.auditResponse.detalle !== undefined && response.auditResponse.detalle.renovarToken) {
            const responseToken = await GeneralRepository.renovarToken()
            if(responseToken !== null && responseToken.error === null) {
                return await obtenerAutorizacionNiubiz(body)
            } else {
                return {
                    error: response.auditResponse,
                    autorizacion: null
                }
            }
        } else {
            return {
                error: response.auditResponse,
                autorizacion: null
            }
        }
    }
}

export const reencolarPagoLink = async (numeroDocumento, nombre, email, link) => {
    const response = await PrimerPagoProvider.reencolarPagoLink({
        documentNumber : numeroDocumento,
        firstNames     : nombre,
        email          : email,
        paymentLink    : link
    })
    if(response.auditResponse.codigoRespuesta === '0') {
        return {
            error: null,
            pagolink: response.entity.data
        }
    } else {
        if(response.auditResponse.detalle !== undefined && response.auditResponse.detalle.renovarToken) {
            const responseToken = await GeneralRepository.renovarToken()
            if(responseToken !== null && responseToken.error === null) {
                return await reencolarPagoLink(numeroDocumento, nombre, email, link)
            } else {
                return {
                    error: response.auditResponse,
                    pagolink: null
                }
            }
        } else {
            return {
                error: response.auditResponse,
                pagolink: null
            }
        }
    }
}